/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Skill = {
  /**
   * Unique identifier for the skill
   */
  id: string;
  /**
   * Unix timestamp when the skill was created
   */
  createdAt: number;
  /**
   * Default version for the skill
   */
  defaultVersion: string;
  /**
   * Description of the skill
   */
  description: string;
  /**
   * Latest version for the skill
   */
  latestVersion: string;
  /**
   * Name of the skill
   */
  name: string;
  object?: "skill" | undefined;
};

/** @internal */
export const Skill$inboundSchema: z.ZodType<Skill, z.ZodTypeDef, unknown> = z
  .object({
    id: z.string(),
    created_at: z.number().int(),
    default_version: z.string(),
    description: z.string(),
    latest_version: z.string(),
    name: z.string(),
    object: z.literal("skill").default("skill"),
  }).transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "default_version": "defaultVersion",
      "latest_version": "latestVersion",
    });
  });
/** @internal */
export type Skill$Outbound = {
  id: string;
  created_at: number;
  default_version: string;
  description: string;
  latest_version: string;
  name: string;
  object: "skill";
};

/** @internal */
export const Skill$outboundSchema: z.ZodType<
  Skill$Outbound,
  z.ZodTypeDef,
  Skill
> = z.object({
  id: z.string(),
  createdAt: z.number().int(),
  defaultVersion: z.string(),
  description: z.string(),
  latestVersion: z.string(),
  name: z.string(),
  object: z.literal("skill").default("skill" as const),
}).transform((v) => {
  return remap$(v, {
    createdAt: "created_at",
    defaultVersion: "default_version",
    latestVersion: "latest_version",
  });
});

export function skillToJSON(skill: Skill): string {
  return JSON.stringify(Skill$outboundSchema.parse(skill));
}
export function skillFromJSON(
  jsonString: string,
): SafeParseResult<Skill, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Skill$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Skill' from JSON`,
  );
}
